module.exports = __webpack_public_path__ + "static/media/Two-user.2872d95e.svg";